import React from 'react';
import { Box, Link as MuiLink, useTheme, useMediaQuery } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PRIVACY, TOS, ABOUT } from 'routes';

/**
 * Reusable footer with About, Privacy, and Terms links.
 */
const FooterLinks: React.FC = () => {
  const { t } = useTranslation('titleToolbar');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        position: 'relative',
        py: 2,
        px: { xs: 2, sm: 4 },
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: isMobile ? 'space-between' : 'flex-end',
        alignItems: 'center',
      }}
    >
      <MuiLink
        component={RouterLink}
        to={ABOUT}
        underline="hover"
        sx={{
          color: 'primary.main',
          flex: isMobile ? '1 1 0' : '0 0 auto',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          textAlign: isMobile ? 'left' : 'center',
          position: isMobile ? 'static' : 'absolute',
          left: isMobile ? undefined : '50%',
          transform: isMobile ? undefined : 'translateX(-50%)',
        }}
      >
        {t('aboutTitle', { ns: 'titleToolbar' })}
      </MuiLink>
        <Box sx={{ display: 'flex', gap: 2, flex: '0 0 auto' }}>
        <MuiLink
          component={RouterLink}
          to={PRIVACY}
          underline="hover"
          sx={{
            color: 'primary.main',
            flex: '0 1 auto',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          {t('privacy', { ns: 'titleToolbar' })}
        </MuiLink>
        <MuiLink
          component={RouterLink}
          to={TOS}
          underline="hover"
          sx={{
            color: 'primary.main',
            flex: '0 1 auto',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          {t('terms', { ns: 'titleToolbar' })}
        </MuiLink>
      </Box>
    </Box>
  );
};

export default FooterLinks;